<template>
  <div class="onboarding-seeker bg-grey-background-subdued">
    <ProgressBar :value="progress.currentStep" :max="progress.totalSteps" :content="progressContent" />
    <RouteStepper
      class="w-full mt-32 max-w-688 px-16 mx-auto"
      :hide-breadcrumb="false"
      breadcrumb-container-class="mx-auto w-full max-w-536"
      :model-value="initialDraftData"
      :auto-validate-on-init="true"
      @progress="progress = $event"
    />
  </div>
</template>

<script lang="ts">
import RouteStepper from '@/components/route_stepper/RouteStepper.vue';
import ProgressBar from '@/components/progress_bar/ProgressBar.vue';
import { CorporateGuidedDraft } from './types';

export default {
  name: 'CorporateOnboardingGuided',
  components: { RouteStepper, ProgressBar },
  data(): { progress: { currentStep: number; totalSteps: number } } {
    return {
      progress: { currentStep: 1, totalSteps: 1 },
    };
  },
  computed: {
    progressContent(): string {
      return `Step ${this.progress.currentStep} of ${this.progress.totalSteps}`;
    },
    initialDraftData(): CorporateGuidedDraft {
      return {};
    },
  },
};
</script>

<style lang="scss">
.onboarding-seeker .card:not(.card-preserve) {
  padding: 24px;

  @media (max-width: 480px) {
    background-color: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
}
</style>
